import { ElementRef } from '@angular/core';
import { State } from '@progress/kendo-data-query';

export class Campaign {
    campaignPageData: CampaignPageData[];
    campaignPageCount: CampaignPageCount;
    total: number;
}

export class CampaignPageData {
    verifiedStudentId: string;
    studentId: string;
    statusId: string;
    firstName: string;
    lastName: string;
    goal: number;
    sponsors: number;
    campaignId: number;
    email: string;
    donationsTotal: number;
    percentsRaised: number;
    startDate: string;
    endDate: string;
    canMoveToDraft: boolean;
    canMoveToActive: boolean;
}
export class CampaignOpen {
    campaignId: number;
    goalAmount: number;
    endDate: string;
}

export class CampaignStats {
    campaignId: number;
    goal: number;
    dollarsRaised: number;
    percentsRaised: number;
    sponsors: number;
    startDate: string;
    endDate: string;
    anchor: ElementRef;
}
class CampaignPageCount {
    draftCount: number;
    activeCount: number;
    completedCount: number;
    archivedCount: number;
}

export interface ICampaignState {
    state: State;
    sortState: ISortState;
}

interface ISortState {
    sortByDefault: string;
    sortByOptions: string[];
    sortByDir: string;
    sortByDirOptions: string[];
}
